/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ClockCircleOutlined } from '@ant-design/icons';
import { Button, Radio } from 'antd';
import { RadioGroup } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import RiskRegisterService from '../../../services/RiskRegister.service';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';

import UserService from '../../../services/UserService';
import { STATUS_ID } from '../STATUS_ID';
import ModalReviewed from './components/ModalReviewed';
import ModalRevise from './components/ModalRevise';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import { getTagStatus } from '../../../util/util';
import useNotify from '../../../context/Notification/useNotify';
import { useTranslation } from 'react-i18next';
import { ROUTER } from '../../../constants/router';
import { t } from 'i18next';

const OPEN_TYPE = {
    CLONING: 'cloning',
    CONNECT: 'connect',
    INITIAL: 'initial',
    CREATE: 'create',
    EDIT: 'edit',
    VIEW: 'view',
};

export default function RegisterInfo({
    setVisibleHistories,
    setIsChangeStatus,
    riskInfo,
    getDetailInfo,
    setSelectRR,
    selectRR,
    riskInfoTabs,
}) {
    const location = useLocation();
    const mode = location?.state?.mode;

    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 pt-4 pb-6 my-4">
            <div
                className="text-sm font-semibold pb-2 flex justify-between items-center"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                <span>
                    {t('RList.RiskRegister')} : {riskInfo?.riskRegisterNumber}
                </span>
                <button
                    onClick={(e) => {
                        setVisibleHistories(true);
                        setIsChangeStatus(true);
                    }}
                    className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                >
                    <ClockCircleOutlined />
                </button>
            </div>
            {mode === OPEN_TYPE.CREATE ||
            mode === OPEN_TYPE.VIEW ||
            mode === OPEN_TYPE.EDIT ? (
                <CreateInfo
                    riskInfo={riskInfo}
                    getDetailInfo={getDetailInfo}
                    riskInfoTabs={riskInfoTabs}
                />
            ) : (
                <CloneInfo
                    selectRR={selectRR}
                    setSelectRR={setSelectRR}
                    mode={mode}
                />
            )}
        </div>
    );
}

const CreateInfo = ({ riskInfo, getDetailInfo }) => {
    const { t, i18n } = useTranslation();
    const notify = useNotify();
    const { riskId } = useParams();
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const [openReview, setOpenReview] = useState(false);
    const [openRevise, setOpenRevise] = useState(false);

    const [loading, setLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);

    const changeStatus = async () => {
        const payload = {
            riskRegisterId: riskId,
            status: STATUS_ID.WAITING_FOR_REVIEW,
        };
        setLoading(true);
        setTimeout(async () => {
            try {
                const { data } = await RiskRegisterService.changeStatus(
                    payload
                );
                if (data.resultCode === 1) {
                    getDetailInfo();
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    getDetailInfo();
                }
            } catch (error) {
                const data = error?.data;
                if (
                    data?.errorData?.msg === 'RISK REGISTER MUST HAVE ACTIVITY'
                ) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('RR.MustLeastActivity'),
                        timeOut: 120000,
                        closeable: true,
                    });
                } else if (
                    data?.errorData?.msg === 'RISK REGISTER TOPIC NEVER USE'
                ) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('RR.MustBeRisk'),
                        timeOut: 120000,
                        closeable: true,
                    });
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: data?.errorData?.msg,
                    });
                }
                setLoading(false);
                setOpenConfirm(false);
            }
        }, 1300);
    };

    const InitialButton = () => {
        // Admin
        if (admin) {
            if (riskInfo?.status === STATUS_ID.REVIEWED) {
                return (
                    <Button
                        onClick={() => setOpenRevise(true)}
                        size="large"
                        type="primary"
                        ghost
                    >
                        {t('RR.Revise')}
                    </Button>
                );
            } else if (riskInfo?.status === STATUS_ID.WAITING_FOR_REVIEW) {
                return (
                    <div className="space-x-4">
                        <Button
                            onClick={() => setOpenRevise(true)}
                            size="large"
                            type="primary"
                            ghost
                        >
                            {t('RR.Revise')}
                        </Button>
                        <Button
                            onClick={() => setOpenReview(true)}
                            size="large"
                            type="primary"
                            className=""
                        >
                            {t('RR.Reviewed')}
                        </Button>
                    </div>
                );
            } else if (riskInfo?.status === STATUS_ID.REVISE) {
                return <div />;
            } else return <div />;
            // User
        } else {
            if (
                riskInfo?.status === STATUS_ID.DRAFT ||
                riskInfo?.status === STATUS_ID.REVISE
            ) {
                return (
                    <Button
                        onClick={() => setOpenConfirm(true)}
                        size="large"
                        type="primary"
                        className=""
                    >
                        {t('RR.SendToReview')}
                    </Button>
                );
            } else return <div />;
        }
    };

    return (
        <>
            <div className="my-4">
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('RR.CreateBy')} :
                    </span>
                    <span className="text-xs">
                        {riskInfo?.createByFullName || '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('RR.CreateDate')} :
                    </span>
                    <span className="text-xs">
                        {riskInfo?.createDate
                            ? moment(riskInfo?.createDate).format(
                                  'DD/MM/YYYY HH:mm'
                              )
                            : '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('RR.LastUpdatedDate')} :
                    </span>
                    <span className="text-xs">
                        {riskInfo?.modifyDate
                            ? moment(riskInfo?.modifyDate).format(
                                  'DD/MM/YYYY HH:mm'
                              )
                            : '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('Version')} :
                    </span>
                    <span className="text-xs">{riskInfo?.version}</span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('Status')} :{' '}
                    </span>
                    <span className="text-xs">
                        {getTagStatus(
                            i18n,
                            riskInfo?.status,
                            riskInfo?.statusEn,
                            riskInfo?.statusTh
                        )}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('RR.Reviewer')} :
                    </span>
                    <span className="text-xs">
                        {riskInfo?.reviewedByFullName || '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('RR.ReviewedDate')} :
                    </span>
                    <span className="text-xs">
                        {riskInfo?.lastReviewDate
                            ? moment(riskInfo?.lastReviewDate).format(
                                  'DD/MM/YYYY HH:mm'
                              )
                            : '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-xs font-semibold w-36">
                        {t('RR.NextReviewDate')} :
                    </span>
                    <span className="text-xs">
                        {riskInfo?.nextReviewDue
                            ? moment(riskInfo?.nextReviewDue).format(
                                  'DD/MM/YYYY HH:mm'
                              )
                            : '-'}
                    </span>
                </div>
            </div>
            <div className="text-center mt-12">
                <InitialButton />
            </div>
            <ModalReviewed
                status={STATUS_ID.REVIEWED}
                getDetailInfo={getDetailInfo}
                open={openReview}
                handelClose={() => setOpenReview(false)}
            />
            <ModalRevise
                status={STATUS_ID.REVISE}
                getDetailInfo={getDetailInfo}
                open={openRevise}
                handelClose={() => setOpenRevise(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={changeStatus}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
};

const CloneInfo = ({ mode, setSelectRR, selectRR }) => {
    const location = useLocation();
    const activityId = location?.state?.activityId;
    const navigate = useNavigate();
    const [detail, setDetail] = useState([]);
    const notify = useNotify();
    const { t, i18n } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openType, setOpenType] = useState('');

    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });

    const cloning = () => {
        setLoading(true);
        setTimeout(async () => {
            try {
                const payload = {
                    riskRegisterId: selectRR?.riskRegisterId,
                };
                const { data } = await RiskRegisterService.cloning(payload);
                if (data?.resultCode === 1) {
                    setOpenConfirm(false);
                    setLoading(false);
                    navigate(
                        `${ROUTER.RISK_MANAGEMENT.RR}/${data?.resultData?.riskRegisterId}`,
                        {
                            state: { mode: 'create' },
                        }
                    );
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                } else {
                    setOpenConfirm(false);
                    setLoading(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            } catch (error) {
                setOpenConfirm(false);
                setLoading(false);
                console.log(error);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        }, 1300);
    };
    const connect = () => {
        setLoading(true);
        setTimeout(async () => {
            try {
                const payload = {
                    riskRegisterId: selectRR?.riskRegisterId,
                    activityId,
                };
                const { data } = await RiskRegisterService.connect(payload);
                if (data?.resultCode === 1) {
                    setOpenConfirm(false);
                    setLoading(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                    navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view`);
                } else {
                    setOpenConfirm(false);
                    setLoading(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            } catch (error) {
                console.log(error);
                setOpenConfirm(false);
                setLoading(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        }, 1300);
    };

    const onSubmit = () => {
        if (openType === OPEN_TYPE.CLONING) {
            cloning();
        }
        if (openType === OPEN_TYPE.CONNECT) {
            connect();
        }
    };

    const getRegistered = async () => {
        let ids =
            mode === OPEN_TYPE.CONNECT
                ? [STATUS_ID.REVISE, STATUS_ID.DRAFT]
                : [
                      STATUS_ID.REVISE,
                      STATUS_ID.DRAFT,
                      STATUS_ID.REVIEWED,
                      STATUS_ID.WAITING_FOR_REVIEW,
                  ];

        try {
            let payload = {
                statusIds: ids.join(','),
                departmentId: 'owner',
                p: currentPage.page,
                ps: 10,
                sd: 'DESC',
            };
            const { data } = await RiskRegisterService.searchRiskRegisterTab2(
                payload
            );
            setLoading(false);
            const resultData = data?.resultData?.result;
            if (resultData?.length > 0) {
                const details = detail.concat(resultData);
                setDetail(details);
                setCurrentPage({
                    page: data?.resultData.page + 1,
                    pageSize: data?.resultData.pageSize,
                    total: data?.resultData.total,
                });
            }
        } catch (err) {
            setCurrentPage({
                page: 1,
                pageSize: 10,
                total: 0,
            });
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        getRegistered();
    }, []);

    useEffect(() => {
        if (detail.length > 0 && currentPage.page === 1) {
            setSelectRR(detail[0]);
            navigate(
                `${ROUTER.RISK_MANAGEMENT.RR}/${detail[0]?.riskRegisterId}`,
                {
                    state: { mode, activityId },
                }
            );
        }
    }, [detail]);

    const onChange = (value) => {
        navigate(`${ROUTER.RISK_MANAGEMENT.RR}/${value?.riskRegisterId}`, {
            state: { mode, activityId },
        });
        setSelectRR(value);
    };

    return (
        <>
            <div className="my-4">
                <RadioGroup value={selectRR} onChange={onChange}>
                    <RadioGroup.Label className="sr-only">
                        {t('RR.Secrets')}
                    </RadioGroup.Label>
                    <div
                        id="scrollableDiv"
                        className="overflow-y-auto max-h-[400px]"
                    >
                        <InfiniteScroll
                            dataLength={detail.length}
                            next={getRegistered}
                            hasMore={detail.length < currentPage.total}
                            scrollableTarget="scrollableDiv"
                            className="space-y-3 p-2"
                            loader={<h4>{t('Loading')}...</h4>}
                        >
                            {detail.map((item) => (
                                <RadioGroup.Option
                                    key={item.riskRegisterNumber}
                                    value={item}
                                    style={{ border: '1px solid #DBDBDB' }}
                                    className={({ active, checked }) =>
                                        `${
                                            active
                                                ? 'ring-2 ring-white ring-opacity-60 ring-offset-1 ring-offset-[#7B67FB]'
                                                : ''
                                        }
                                        ${
                                            checked &&
                                            'ring-2 ring-white ring-opacity-60 ring-offset-1 ring-offset-[#7B67FB]'
                                        }
                                           relative flex cursor-pointer rounded-lg px-5 py-4 focus:outline-none `
                                    }
                                >
                                    {({ checked }) => (
                                        <div className="flex w-full text-sm">
                                            <RadioGroup.Label
                                                as="div"
                                                className="w-full items-center justify-between flex"
                                            >
                                                <Radio checked={checked}>
                                                    {item.riskRegisterNumber}
                                                </Radio>
                                                <span>
                                                    {getTagStatus(
                                                        i18n,
                                                        item?.status,
                                                        item?.statusEn,
                                                        item?.statusTh
                                                    )}
                                                </span>
                                            </RadioGroup.Label>
                                        </div>
                                    )}
                                </RadioGroup.Option>
                            ))}
                        </InfiniteScroll>
                    </div>
                </RadioGroup>
            </div>
            <div className="text-center mt-12">
                {mode === 'connect' ? (
                    <Button
                        onClick={() => {
                            setOpenConfirm(true);
                            setOpenType(OPEN_TYPE.CONNECT);
                        }}
                        size="large"
                        type="primary"
                        className=""
                    >
                        {t('RR.ConfirmConnect')}
                    </Button>
                ) : (
                    <Button
                        onClick={() => {
                            setOpenConfirm(true);
                            setOpenType(OPEN_TYPE.CLONING);
                        }}
                        size="large"
                        type="primary"
                        className=""
                    >
                        {t('RR.ConfirmCopy')}
                    </Button>
                )}
            </div>
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
};
